import type { SmModelsResponse } from '@/types/catalog'
import { useInfiniteQuery } from '@tanstack/react-query'
import { getSmModels } from '@/api/models'
import { queryKeys } from '@/query/queryKeys'

export const SM_MODELS_PAGE_SIZE = 7

interface UseSmModelsInfiniteQueryOptions {
  season: string
  superModelId: number
}

export function useSmModelsInfiniteQuery({ season, superModelId }: UseSmModelsInfiniteQueryOptions) {
  return useInfiniteQuery({
    queryKey: queryKeys.smModelsInfiniteQuery(season, superModelId),
    queryFn: ({ pageParam }) => getSmModels({
      season,
      superModelId,
      page: pageParam,
      pageSize: SM_MODELS_PAGE_SIZE,
    }),
    initialPageParam: 0,
    getNextPageParam: (lastPage: SmModelsResponse) => {
      const nextPage = lastPage.page_request.page_index + 1
      return nextPage < lastPage.total_pages ? nextPage : undefined
    },
  })
}
